import styled from '@emotion/styled'
import { IconButton } from '@mui/material'

export const SquareIconButton = styled(IconButton)`
  padding: 7px;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #eeeeee;
`
